<style lang="stylus">
    .usertask-box
        position absolute
        width 300px
        max-height 490px
        background #FFFFFF
        box-shadow 0px 6px 18px rgba(0, 0, 0, 0.1)
        border-radius 8px
        pointer-events auto
        transform-origin right bottom
        transform scale(0)
        transition .3s

        &.animation-done
            transform scale(1)

        .overflow
            white-space nowrap
            text-overflow ellipsis
            overflow hidden

        .usertask-box-close
            position absolute
            right 8px
            top 8px
            cursor pointer
            z-index 1

        .usertask-box-head
            height 126px

            .usertask-head-titlebox
                height 80px
                width 100%
                padding 20px 18px 20px

                .usertask-head-title
                    max-width 264px
                    font-size 16px
                    color #222
                    font-weight 700
                    line-height 20px
                    margin-bottom 6px

                .usertask-head-subtitle
                    max-width 264px
                    font-size 12px
                    color #222
                    line-height 16px

            .usertask-head-contentbox
                height 46px
                width 100%
                padding 4px 24px

                .usertask-head-task
                    font-size 12px
                    line-height 16px
                    color #333
                    margin-bottom 8px

                    .usertask-head-progress
                        color #fdaa2d
                        margin-left 6px

                .usertask-head-bar
                    width 140px
                    height 6px

                    .usertask-progress-outer
                        width 100%
                        height 6px
                        background rgba(224, 237, 255, 0.8)
                        backdrop-filter blur(8px)
                        border-radius 4px

                        .usertask-process-inner
                            height 6px
                            background linear-gradient(91.15deg, rgba(179, 143, 255, 0.5) -33.49%, rgba(207, 249, 255, 0) 97.63%), linear-gradient(105.47deg, #3D7FFF 21.68%, #8FE4FF 76.52%);
                            border-radius 3px

        .usertask-box-body
            padding 16px 0

            @media screen and (max-height: 550px)
                max-height 300px
                overflow-y scroll
                overflow-x hidden
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: rgba(0,0,0,0.1);
                -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
                border-radius: 10px;
            }

            .usertask-body-item
                height 60px
                width 100%
                display flex
                justify-content space-between
                align-items center
                padding 0 16px

                &:not(:last-child)
                    margin-bottom 8px

                .usertask-item-icon
                    display block
                    width 32px
                    height 32px
                    margin-right 10px

                .usertask-item-text
                    height 38px
                    width 150px
                    flex 1

                    .usertask-item-title
                        max-width 100%
                        font-size 12px
                        color #000
                        font-weight 700
                        line-height 18px
                        margin-bottom 2px

                    .usertask-item-reward
                        max-width 100%
                        font-size 12px
                        color #017FFF
                        line-height 18px
                        margin-bottom 2px

                .usertask-item-btn
                    display flex
                    align-items center
                    justify-content center
                    width 60px
                    height 24px
                    background linear-gradient(99.24deg, #62AEFF 0%, #017FFF 98.57%)
                    border-radius 20px

                    &:not(.active):hover
                        background linear-gradient(99.24deg, #B7DAFF 0%, #1589FF 98.57%)
                        cursor pointer

                    &.active
                        background #F0F0F0

                        p
                            color #999999

                    p
                        color #fff
                        font-size 12px
                        line-height 20px
</style>

<template>
    <div class="usertask-box" :class="{ 'animation-done': animation }" :style="boxPositon" v-show="showBox">
        <div class="usertask-box-close" @click="closeBox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7L17 17" stroke="#424242" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7 17L17 7" stroke="#424242" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div
            class="usertask-box-head"
            :style="{
                background: `url(${require('@/public/img/task/banner.png')})`,
                backgroundSize: '100% 100%',
            }"
        >
            <div class="usertask-head-titlebox">
                <p class="usertask-head-title overflow" :title="$t('title')">{{ $t("title") }}</p>
                <p class="usertask-head-subtitle">{{ $t("subTitle") }}</p>
            </div>
            <div class="usertask-head-contentbox">
                <p class="usertask-head-task">
                    {{ $t("mission") }}
                    <span class="usertask-head-progress">{{ progress * 100 + "%" }}</span>
                </p>
                <div class="usertask-head-bar">
                    <div class="usertask-progress-outer">
                        <div :style="{ width: `${140 * progress}px` }" class="usertask-process-inner"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="usertask-box-body">
            <div class="usertask-body-item" v-for="item in taskList" :key="item.id">
                <img
                    class="usertask-item-icon"
                    :src="require(`@/public/img/task/task-${item.name}1x.png`)"
                    :srcset="
                        require(`@/public/img/task/task-${item.name}2x.png`) +
                        ' 2x' +
                        ',' +
                        require(`@/public/img/task/task-${item.name}1x.png`) +
                        ' 1x'
                    "
                    alt=""
                />
                <div class="usertask-item-text">
                    <p class="usertask-item-title overflow">{{ item.desc }}</p>
                    <i18n path="reward" tag="p" class="usertask-item-reward">
                        <template #num>
                            {{ item.reward_num }}
                        </template>
                        <template #data>
                            {{ item.reward_type == 1 ? $t("reward1") : $t("reward2") }}
                        </template>
                    </i18n>
                    <!-- <p class="usertask-item-reward overflow">{{
                        getRewardText(item.reward_type, item.reward_num)
                    }}</p> -->
                </div>
                <div class="usertask-item-btn" :class="{ active: item.status }" @click="!item.status && clickBtn(item)">
                    <p>{{ item.status == 0 ? $t("todo") : $t("done") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class UserTaskBox extends Vue {
        @Prop()
        showBox;
        @Prop()
        progress;
        @Prop()
        taskList;
        @Prop()
        customOffset;

        animation = false;
        position = {
            right: 32,
            bottom: 86,
        };

        get boxPositon() {
            if (this.customOffset) {
                return `right: ${this.position.right + this.customOffset.right}px; bottom: ${this.position.bottom + this.customOffset.bottom}px`;
            } else {
                return `right: ${this.position.right}px; bottom: ${this.position.bottom}px`;
            }
        }

        @Watch("showBox")
        watchShow(nv, ov) {
            if (nv) {
                setTimeout(() => {
                    this.animation = true;
                }, 50);
                console.log(this.taskList);
            } else {
                this.animation = false;
            }
        }

        getRewardText(type: number, num: number) {
            return `奖励${num}个${type == 1 ? "云文件编辑权限" : "社区会员模板"}`;
        }

        clickBtn(e) {
            this.$emit("clickTask", e);
        }

        closeBox() {
            this.$emit("close");
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
    "zh": {
        "title": "欢迎来到亿图图示",
        "subTitle": "跟着指引开始您的绘图之旅吧~",
        "mission": "新手任务",
        "todo": "去完成",
        "done": "已获得",
        "reward": "奖励{num}个{data}",
        "reward1": "云文件编辑权限",
        "reward2": "社区会员模板"
    },
    "en": {
        "title": "Welcome to EdrawMax",
        "subTitle": "Follow the guide to start your drawing journey.",
        "mission": "Task",
        "todo": "complete",
        "done": "completed",
        "reward": "Reward {num} {data}",
        "reward1": "cloud file editing permission",
        "reward2": "community membership template"
    }
}
</i18n>
